import React from "react";

export default function ZPartnerLSC0Footer() {
    return (
        <div className="absolute-footer bg-white">
            <div className="container clearfix">
                <p className="float-none mb-1 text-center">©2026 Coffee Concepts Retail Co.,Ltd. All rights reserved.</p>
            </div>
        </div>
    );
}
